import script from "./ChatInsightCallout.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatInsightCallout.vue?vue&type=script&setup=true&lang=js"

import "./ChatInsightCallout.vue?vue&type=style&index=0&id=4137c66e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4137c66e"]])

export default __exports__